(function () {
    'use strict';
    var multiSelectId = 0;
    angular.module('SMART2').directive('smartMultiselect', ['$timeout', '$translate', 'RuleEngine', function ($timeout, $translate, RuleEngine) {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                label: '@',
                options: '=?',
                ngModel: '=?',
                isMandatory: '@',
                isVisible: '=?',
                rules: '@',
                validate: '=?',
                focus: '=?',
                onChange: '&',
                onSelect: '&',
                onBlur: '&',
                disable: '@',
                readonly: '@',
                multiple: '@',
                datakey: '@',
                removable: '@',
                autocomplete: '@',
                filterkeys: '@',
                optionformat: '@',
                displayformat: '@',
                width: '@'
            },
            link: function (scope, element, attrs) {
                var options;
                var filterKeys;
                scope.defaultText = "";
                var disableBlurEvent = true;
                if (attrs.id != undefined || attrs.id != null) {
                    scope.multiSelectId = attrs.id;
                    element.removeAttr('id');
                }
                else {
                    multiSelectId = multiSelectId + 1;
                    scope.multiSelectId = 'multiselect-' + multiSelectId;
                }
                scope.labelForMultiSelectId = 'label-for-' + scope.multiSelectId;
                scope.displayformat = scope.displayformat ? scope.displayformat : '{title}';
                scope.$watch('ngModel', function (newValue) {
                    scope.selectedOptions = newValue;
                });

                scope.multiSelectFocus = function () {
                    if (!scope.$eval(scope.disable) && !scope.$eval(scope.readonly))
                        $("#" + scope.multiSelectId).focus();
                };

                scope.setDisplayFormat = function (item) {
                    var displayArray = scope.displayformat.substring(1, scope.displayformat.length - 1);
                    displayArray = displayArray.replace(/  +/g, ' ');
                    var valu = "";
                    var arrayD = displayArray.split('} {');
                    for (var i = 0; i < arrayD.length; i++) {
                        valu += item[arrayD[i]] + " ";
                    }
                    return valu;
                }
                var currentSelectForDelete = scope.ngModel.length;

                scope.ngKeyDown = function (event) {
                    if (event.keyCode === 40 && event.target.value == '') {
                        event.stopImmediatePropagation();
                    }
                    if (scope.ngModel.length > 0) {
                        if ((event.keyCode === 8 || event.keyCode === 46) && scope.defaultText == "") {
                            if (currentSelectForDelete >= scope.ngModel.length) {
                                currentSelectForDelete = scope.ngModel.length - 1;
                                if ((scope.ngModel[currentSelectForDelete].selectForDelete) === false) {
                                    scope.ngModel[currentSelectForDelete].selectForDelete = true;
                                    currentSelectForDelete = scope.ngModel.length - 1;
                                }
                                else {
                                    scope.ngModel.splice(currentSelectForDelete, 1);
                                    currentSelectForDelete = scope.ngModel.length;

                                    var isInvalidId = _.find(scope.ngModel, { "isInvalid": true });
                                    if (!isInvalidId) {
                                        scope.invalidEmailId = false;
                                        scope.validate = false;
                                        scope.errorMessage = null;
                                    }
                                }
                            }
                            else if ((scope.ngModel[currentSelectForDelete].selectForDelete) === true) {
                                scope.ngModel.splice(currentSelectForDelete, 1);
                                currentSelectForDelete = scope.ngModel.length;
                            }
                        }
                        else if (event.keyCode === 37 && scope.defaultText == "") {
                            if (currentSelectForDelete > 0) {
                                scope.ngModel[currentSelectForDelete - 1].selectForDelete = true;

                                if (currentSelectForDelete < scope.ngModel.length)
                                    scope.ngModel[currentSelectForDelete].selectForDelete = false;

                                currentSelectForDelete--;
                            }
                        }
                        else if (event.keyCode === 39 && scope.defaultText == "") {
                            if (currentSelectForDelete < scope.ngModel.length - 1) {
                                scope.ngModel[currentSelectForDelete + 1].selectForDelete = true;

                                if (currentSelectForDelete >= 0)
                                    scope.ngModel[currentSelectForDelete].selectForDelete = false;

                                currentSelectForDelete++;
                            }
                        }
                        else {
                            if (currentSelectForDelete < scope.ngModel.length) {
                                scope.ngModel[currentSelectForDelete].selectForDelete = false;
                            } else {
                                var isInvalidId = _.find(scope.ngModel, { "isInvalid": true });
                                if (isInvalidId) {
                                    scope.invalidEmailId = true;
                                } else {
                                    scope.invalidEmailId = false;
                                    scope.validate = false;
                                    scope.errorMessage = null;
                                }
                            }
                        }
                    } else {
                        scope.invalidEmailId = false;
                        scope.validate = false;
                        scope.errorMessage = null;
                    }
                };

                var checkEmailValidation = function (event, onBlur) {
                    if (event.keyCode == 13 || event.keyCode == 9 || onBlur) {

                        var currentTextValue = element.find('.multiselect-input').val().split(';'),
                            pattern = /^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;

                        var filteredArray = [],
                            invalidEmailArray = [];
                        angular.forEach(currentTextValue, function (item) {
                            if (item) filteredArray.push(item);
                        });

                        for (var i = 0; i < filteredArray.length; i++) {
                            if (filteredArray[i] != '') {
                                var currentItem = { UserName: filteredArray[i], value: filteredArray[i] };
                                if (!pattern.test(filteredArray[i])) {
                                    currentItem.isInvalid = true;
                                    scope.invalidEmailId = true;
                                    invalidEmailArray.push(currentItem);
                                } else {
                                    currentItem.isInvalid = false;
                                    scope.invalidEmailId = false;
                                }

                                if (!currentItem.isInvalid) {
                                    scope.ngModel.push(currentItem);
                                    scope.setDisplayFormat(currentItem);
                                    scope.defaultText = "";
                                    $timeout(function () {
                                        scope.onSelect({
                                            $event: {
                                                data: currentItem
                                            }
                                        });
                                        currentSelectForDelete = scope.ngModel.length;
                                        scope.validateRules();
                                        disableBlurEvent = true;
                                    });
                                }
                                else {
                                    scope.validateRules();
                                }
                            }
                            else {
                                return false;
                            }
                        }
                        var result = invalidEmailArray.map(function (item) { return item.UserName; });
                        scope.defaultText = result.join(';');
                        if (result.length > 0)
                            scope.invalidEmailId = true;
                        scope.validateRules();
                    }
                };

                scope.ngKeyUp = function (event, onBlur) {
                    checkEmailValidation(event, onBlur);
                };

                scope.deleteSelected = function (elementIndex) {
                    disableBlurEvent = false;
                    scope.ngModel.splice(elementIndex, 1);
                    //scope.defaultText = "";
                    $("#" + scope.multiSelectId).focus();
                    var isInvalidId = _.find(scope.ngModel, { "isInvalid": true });
                    if (scope.ngModel.length === 0 || !isInvalidId) {
                        scope.invalidEmailId = false;
                        scope.validate = false;
                        scope.errorMessage = null;
                        return;
                    }
                };

                scope.$watch('validate', function (newVal, oldVal) {
                    if (newVal) {
                        scope.validateRules();
                    }
                });

                scope.ngChange = function (e) {
                    scope.onChange({
                        $event: {
                            data: angular.element('#' + scope.multiSelectId)
                        }
                    });
                };

                scope.ngBlur = function (e) {
                    function checkChipIsDeleted() {
                        if (disableBlurEvent) {
                            scope.ngKeyUp(e, true);
                        }
                        disableBlurEvent = true;
                    }
                    //Timeout is being added to differentiate between blur and delete chip click event.  
                    $timeout(checkChipIsDeleted, 200);
                    scope.onBlur({ $event: e });
                };

                scope.validateRules = function () {
                    if (scope.readonly == 'true') {
                        return;
                    }

                    var isInvalidId = _.find(scope.ngModel, { "isInvalid": true });
                    if (scope.invalidEmailId || isInvalidId) {
                        scope.validate = true;
                        scope.errorMessage = $translate.instant("invalidEmailErrMsg");
                        return;
                    }

                    if (scope.$eval(scope.isMandatory) && (scope.ngModel + '' == '' || scope.ngModel == null || scope.ngModel == undefined)) {
                        scope.validate = true;
                        scope.errorMessage = $translate.instant("enterValueErrMsg");
                        return;
                    }

                    scope.validate = false;
                    scope.errorMessage = null;

                    if (scope.rules) {
                        var rules = scope.$eval(scope.rules);
                        var isFoundInvalid = false;

                        for (var i = 0; i < rules.length; i++) {
                            if (typeof rules[i] == 'object') {
                                if (eval((rules[i].rule).replace(/this/g, 'scope.ngModel'))) {
                                    scope.validate = true;
                                    scope.errorMessage = rules[i].error;
                                    break;
                                }
                            }
                            else {
                                if (!isFoundInvalid) {
                                    if (typeof scope.ngModel != 'object')
                                        var data = scope.ngModel;
                                    else
                                        var data = scope.displayModel;

                                    RuleEngine.isValid(rules[i], function (e) {
                                        scope.validate = true;
                                        scope.errorMessage = e.errorData.error;
                                        isFoundInvalid = true;
                                    }, data);
                                }
                                else {
                                    break;
                                }
                            }
                        }
                    }
                };


                if (angular.isDefined(scope.filterkeys) && scope.filterkeys.trim().indexOf('[') == 0) {
                    filterKeys = scope.filterkeys ? scope.$eval(scope.filterkeys) : ['title'];
                }
                else {
                    filterKeys = scope.filterkeys ? scope.$eval('[' + scope.filterkeys + ']') : ['title'];
                }
                var optionFormat = scope.optionformat ? scope.optionformat : '{title}';
                var displayFormat = scope.displayformat ? scope.displayformat : '{title}';

                function getFormattedData(data) {
                    if (!data || data.length == 0) {
                        return [];
                    }
                    for (var i = 0; i < data.length; i++) {
                        var str = displayFormat;
                        try {
                            var parentSplit = str.split('{');
                            for (var j = 0; j < parentSplit.length; j++) {
                                var childSplit = parentSplit[j].split('}');
                                for (var k = 0; k < childSplit.length; k++) {
                                    if (childSplit[k].indexOf('.') > 0 || data[i].hasOwnProperty(childSplit[k])) {
                                        str = str.replace(new RegExp("{" + childSplit[k] + "}", "ig"), eval('data[i].' + childSplit[k]));
                                    }
                                }
                            }
                        }
                        catch (e) { }
                        data[i].value = str.trim();
                    }
                    return data;
                };

                scope.$watch('options', function (newOptions) {
                    try {
                        if (!$('#' + scope.multiSelectId).devbridgeAutocomplete()) {
                            $('#' + scope.multiSelectId).devbridgeAutocomplete({
                                filterKeys: filterKeys,
                                optionFormat: optionFormat,
                                displayFormat: displayFormat,
                                lookup: getFormattedData(newOptions),
                                width: scope.width,
                                onSelect: function (suggestion) {

                                    scope.$evalAsync(function () {
                                        scope.ngModel.push(suggestion);
                                    });
                                    $(this).focus();
                                    scope.defaultText = "";
                                    $timeout(function () {
                                        scope.defaultText = "";
                                        scope.onSelect({
                                            $event: {
                                                data: suggestion
                                            }
                                        });
                                        currentSelectForDelete = scope.ngModel.length;
                                        scope.validateRules();
                                    });
                                    angular.element('.autocomplete-suggestions').hide();

                                }
                            });
                        }
                        else {
                            $('#' + scope.multiSelectId).devbridgeAutocomplete().setLookup(getFormattedData(newOptions));
                        }
                    }
                    catch (e) { }
                });

                /*
				 * Destroy autocomplete on scope destroy
				 */
                scope.$on('$destroy', function () {
                    if ($('#' + scope.multiSelectId).devbridgeAutocomplete()) {
                        $('#' + scope.multiSelectId).devbridgeAutocomplete().dispose();
                    }
                });

            },
            templateUrl: 'shared/directives/uiElements/smartMultiselect/smartMultiselectTemplate.html'
        }
    }]
	)
})();